import { render, staticRenderFns } from "./shopify.vue?vue&type=template&id=48acef1c&scoped=true"
import script from "./shopify.vue?vue&type=script&lang=js"
export * from "./shopify.vue?vue&type=script&lang=js"
import style0 from "./shopify.vue?vue&type=style&index=0&id=48acef1c&prod&scoped=true&lang=css"
import style1 from "./shopify.vue?vue&type=style&index=1&id=48acef1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48acef1c",
  null
  
)

export default component.exports